import { Injectable } from '@angular/core';

@Injectable()
export class TranslationService {
	private _lang: string;

	constructor() {
		// this._lang = localStorage.getItem("lang") || "cs";
	}

	setLang(lang: string) {
		if (this._lang != lang) {
			this._lang = lang;
			// TODO: publish event
		}
	}

	getString(def: string, replace?: Object) {
		let result = def;

		// replace variables
		if (replace != null) {
			for (let key in replace) {
				if (replace.hasOwnProperty(key)) {
					result = result.replace('{' + key + '}', replace[key]);
				}
			}
		}

		return result;
	}
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/core/services/translation.service.ts